import Vue from "vue";

function applyPermission(el, binding, vnode) {
  const code = binding.value;
  if (!code) return;

  const store = vnode.context && vnode.context.$store;
  const globalCodes =
    (store &&
      store.state &&
      store.state.privilege &&
      store.state.privilege.buttonCodes) ||
    [];

  // 作用域：按当前路由的 dashboard 子路径，匹配 menu 节点下的按钮权限
  // 例如：/interviewer/dashboard/schedule 仅允许 schedule 菜单下的 btn_xxx
  const routePath =
    vnode.context && vnode.context.$route && vnode.context.$route.path
      ? vnode.context.$route.path
      : "";
  const menuButtonCodesByPath =
    (store &&
      store.state &&
      store.state.privilege &&
      store.state.privilege.menuButtonCodesByPath) ||
    {};
  const scopedCodes = routePath && menuButtonCodesByPath[routePath] ? menuButtonCodesByPath[routePath] : null;

  const codesToCheck = scopedCodes && scopedCodes.length ? scopedCodes : globalCodes;

  if (!codesToCheck.includes(code)) {
    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
}

Vue.directive("has", {
  inserted(el, binding, vnode) {
    applyPermission(el, binding, vnode);
  },
  update(el, binding, vnode) {
    applyPermission(el, binding, vnode);
  },
});

